module.exports = __webpack_public_path__ + "img/Banner_4.3b734147.svg";